import React from 'react';
import PropTypes from 'prop-types';
import Sitename from './sitename';
import Description from './description';
import Image from './image';
import Url from './url';
import Video from './Video';
import Title from './Title';
import Noindex from './noindex';

function CommonMeta(props) {
  const { meta } = props;

  return (
    <>
      <Title content={meta.title} />
      <Description content={meta.description} />
      <Image content={meta.image} />
      <Url content={meta.url} />
      <Video content={meta.video} />
      {meta.robots && <Noindex content="noindex" />}
      <Sitename />
    </>
  );
}

CommonMeta.propTypes = {
  meta: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    url: PropTypes.string,
    video: PropTypes.string,
    image: PropTypes.string,
    robots: PropTypes.bool,
  }),
};

CommonMeta.defaultProps = {
  meta: {},
};

export default CommonMeta;
